import script from "./_Page.vue?vue&type=script&lang=js"
export * from "./_Page.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__